
import { memo } from "react";
import { Typography } from "@material-ui/core";
import { PedidoProdutoModel } from "../../../../model/api/pedidos/pedido-produto-model";

interface InfoProdInterface {
    produto: PedidoProdutoModel;
    qtdPai: number
}

const CardInfoProdutoSubItemMotoboy = ({ produto, qtdPai }: InfoProdInterface) => {

    return (
        <div style={{ marginLeft: '8px' }}>
            <Typography
                variant="body2"
                color="textSecondary"
            >
                {produto.quantidade <= 1 ? produto.quantidade : (produto.quantidade / qtdPai)}x {produto.descricao}
            </Typography>


            {produto?.subItens &&
                produto?.subItens.length > 0 &&
                produto.subItens.map((p, index) => (
                    <CardInfoProdutoSubItemMotoboy
                        key={index}
                        produto={{ ...p, quantidade: produto.quantidade === 0 ? 0 : p.quantidade }}
                        qtdPai={qtdPai}
                    />
                ))}
        </div>
    );
};

export default memo(CardInfoProdutoSubItemMotoboy)